(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallResultGroupDeleteController',PhoneCallResultGroupDeleteController);

    PhoneCallResultGroupDeleteController.$inject = ['$uibModalInstance', 'entity', 'PhoneCallResultGroup'];

    function PhoneCallResultGroupDeleteController($uibModalInstance, entity, PhoneCallResultGroup) {
        var vm = this;

        vm.phoneCallResultGroup = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PhoneCallResultGroup.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
